'use strict';

import {module} from '../app';

module.service('Config', [
    '$http', function ($http) {
      return {
        getConfig: function () {
          return $http.get(`/Custom/public/config.json?v=${new Date().getTime()}`);
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/domains/config.js